import {User} from '../user';

export function toString(this: User) {
    return `User: ${this.id}`;
}
